import { Box, Stack } from "@mui/material";
import { Ellipse, EllipseLeft, EllipseLeft2, EllipseLeft3, EllipseRight, EllipseRight2, EllipseRight3 } from "./Style";

const Background = () => {

    const sx = {
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        zIndex: 0,
        backgroundColor: 'transparent',
        overflow: "hidden"

    };

    return (
        <Box sx={sx} >
            <Stack
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "80vh"
                }}
            >
                {/* <EllipseLeft />
                <EllipseLeft2 />
                <EllipseLeft3 /> */}
                <EllipseRight />
                <EllipseRight2 />
                <EllipseRight3 />
            </Stack>
            <Stack
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "80vh"
                }}
            >
                <EllipseLeft />
                <EllipseLeft2 />
                <EllipseLeft3 />
            </Stack>
            <Stack
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "80vh"
                }}
            >
                {/* <EllipseLeft />
                <EllipseLeft2 />
                <EllipseLeft3 /> */}
                <EllipseRight />
                <EllipseRight2 />
                <EllipseRight3 />
            </Stack>
            <Stack
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "80vh"
                }}
            >
                <EllipseLeft />
                <EllipseLeft2 />
                <EllipseLeft3 />
            </Stack>
        </Box>
    );
}

export default Background;